import { BreadcrumbComponentModule } from "./../_component/breadcrumb/breadcrumb.module";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "../../_component/header/header.module";
import { PaginationClientSideModule } from "../_component/pagination-client-side/pagination-client-side.module";
import { SpaceAssignmentEditModule } from "../_component/_space/space-assignment-edit/space-assignment-edit.module";
import { SpaceReservationsComponentModule } from "../_component/_space/space-reservations/space-reservations.module";
import { ParkingPageRoutingModule } from "./parking-routing.module";
import { ParkingPage } from "./parking.page";
import { SpaceAssignmentViewModule } from "../_component/_space/space-assignment-view/space-assignment-view.module";
import { UserAssignmentViewModule } from "../_component/_space/user-assignment-view/user-assignment-view.module";
import { SpaceViewModule } from "../_component/_space/space-view/space-view.module";
import { SpaceListModule } from "../_component/_space/space-list/space-list.module";
import { SpaceAddReservationComponentModule } from "../_component/_space/space-add-reservation/space-add-reservation.module";
import { SpaceMapEditComponentModule } from "../_component/_space/space-map-edit/space-map-edit.module";
import { ParkingFilterModule } from "../_component/_space/space-filter/space-filter.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ParkingPageRoutingModule,
    HeaderModule,
    TranslateModule,
    SpaceViewModule,
    SpaceAssignmentViewModule,
    UserAssignmentViewModule,
    SpaceAssignmentEditModule,
    PaginationClientSideModule,
    SpaceListModule,
    SpaceAddReservationComponentModule,
    SpaceReservationsComponentModule,
    BreadcrumbComponentModule,
    SpaceMapEditComponentModule,
  ],
  declarations: [ParkingPage],
})
export class ParkingPageModule {}
